/* eslint-disable import/no-named-as-default-member */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import translationEN from './locales/en/translation.json';
import translationSV from './locales/sv/translation.json';

// Define the resources
const resources = {
  en: {
    translation: translationEN,
  },
  sv: {
    translation: translationSV,
  },
};

i18n
  .use(LanguageDetector) // Optional: detects user language from browser settings
  .use(initReactI18next) // Connects with React
  .init({
    resources,
    fallbackLng: 'sv',
    debug: process.env.NODE_ENV === 'development',
    load: 'languageOnly', // This tells i18next to load only the language code (e.g., "sv" from "sv-SE")
    supportedLngs: ['en', 'sv'],
    nonExplicitSupportedLngs: true,
    checkWhitelist: true, // Enforces fallback if the detected language isn't whitelisted
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

// Log the normalized language when it's set or changed.
i18n.on('languageChanged', () => {
  console.log('Raw language:', i18n.language);
  console.log('Resolved language:', i18n.resolvedLanguage);
});

export default i18n;
